import type { StateCreator } from 'zustand'

import type { AllSlices } from '../types'
import type { PaymentSlice } from '../types/payment'

export const createPaymentSlice: StateCreator<
  AllSlices,
  [],
  [],
  PaymentSlice
> = set => ({
  paymentChannels: [],
  setPaymentChannels: paymentChannels =>
    set(state => ({ payment: { ...state.payment, paymentChannels } })),
})
